"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLUG_SWITCH_ID_MODIFIER = exports.mapSwitches = void 0;
const mapSwitches = (switchDevices, things) => switchDevices.map((s) => {
    const thing = things.find((t) => t.deviceId === s.id);
    return Object.assign(Object.assign({}, s), { isGen2: !!thing });
});
exports.mapSwitches = mapSwitches;
exports.PLUG_SWITCH_ID_MODIFIER = "switch-";
//# sourceMappingURL=Switches.js.map